<template>
    <div class="video-details">
        <h1 class="video-details__title">{{ video.title }}</h1>

        <ul class="video-details__meta">
            <li
                v-if="video.status === 'published'"
                data-verify-icon
            >
                <BaseIcon icon="check-decagram" />
                <span>reviewed by peers</span>
            </li>
            <li v-if="video.status === 'in-review'">
                <BaseIcon icon="pending-actions" />
                <span>under review</span>
            </li>
            <!-- <li>
                <BaseIcon icon="visibility" />
                <span>{{ viewsLabel }}</span>
            </li> -->
            <li>
                <span><BaseDate :iso-date="video.created_at" /></span>
            </li>
        </ul>

        <div
            v-if="video.tags && video.tags.length > 0"
            class="video-details__tags"
        >
            <BaseTag
                v-for="tag in video.tags"
                :key="tag.id"
                :element="`button`"
                type="button"
                class="base-tag--light base-tag--responsive"
                @click="router.push({ query: { q: tag.label } })"
            >
                {{ tag.label }}
            </BaseTag>
        </div>

        <div class="video-details__author">
            <BaseUser
                :title="video.user?.full_name"
                :subtitle="userSubtitle"
                :image="video.user?.avatar?.conversions?.webp_256"
            />
        </div>

        <div class="video-details__description" :style="`--description-height: ${descriptionHeight}px`">
            <Transition name="description">
                <div v-show="descriptionExpanded">
                    <div ref="expandableRef" class="video-details__expandable">
                        <p v-if="video.description">{{ video.description }}</p>
                        <h3>Informed consent</h3>
                        <p>Patient was informed prior to procedure and consented for anonymous publication of educational video by signing</p>
                        <template v-if="video.conflict_of_interest">
                            <h3>Conflicts of interest</h3>
                            <p>{{ video.conflict_of_interest_explanation }}</p>
                        </template>
                        <template v-if="video?.medical_tools_used">
                            <h3>Devices used</h3>
                            <p>{{ video.medical_tools_used }}</p>
                        </template>
                    </div>
                </div>
            </Transition>
            <button
                class="video-details__expand-button"
                :gtm-video-show-details="descriptionExpanded ? null : 'true'"
                :gtm-video-hide-details="descriptionExpanded ? 'true' : null"
                @click="toggleDescription"
            >
                {{ descriptionExpanded ? 'Hide details' : 'Show more details' }}
            </button>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    video: {
        type: Object,
        default: null,
        required: true
    }
});

const router = useRouter();

const expandableRef = ref(null);

const descriptionExpanded = ref(false);

const descriptionHeight = ref(0);

// const viewsLabel = computed(() => {
//     if (!props.video?.views) {
//         return '0 views';
//     }
//
//     if (props.video.views === 1) {
//         return '1 view';
//     }
//
//     return `${toValue(props.video.views).toLocaleString()} views`;
// });

const userSubtitle = computed(() => {
    const { user } = props.video;
    if (!user || (!user.job_title && !user.institute)) {
        return '';
    }

    if (user.job_title && user.institute) {
        return `${user.job_title} at ${user.institute}`;
    }

    return user.job_title || user.institute;
});

function toggleDescription() {
    descriptionExpanded.value = !descriptionExpanded.value;

    nextTick(() => {
        descriptionHeight.value = expandableRef.value.getBoundingClientRect().height;
    });
}
</script>

<style lang="less" src="./VideoDetails.less" />
